/**
 * Static fallback for non-React contexts (route guards, middleware).
 * In React components, prefer useRoles().adminRoles for dynamic admin detection.
 */
export const ADMIN_ROLES: string[] = [
	"super_admin",
	"admin",
	"regional_manager",
	"franchise_owner",
];
